import { CreateKlusModel } from "@personeel/models/CreateKlusModel";
import { usePersoneelsdienstenStore } from "@personeel/stores/PersoneelsdienstenStore";
import { DateTime } from "luxon";

export function IsKlusInDienst(klus: CreateKlusModel) {
  if (klus.dienst && klus.beginTijd.trim() !== "" && klus.eindTijd.trim() !== "") {
    const validDienst = usePersoneelsdienstenStore.getState().dienstSleutelIndex.get(klus.dienst);

    if (validDienst === undefined) {
      return "Dienst niet gevonden";
    }

    const klusBegindatumtijd = DateTime.fromFormat(
      `${klus.beginDatum} ${klus.beginTijd}`,
      "yyyy-MM-dd HH:mm",
    );
    const klusEindDatumTijd = DateTime.fromFormat(
      `${klus.eindDatum} ${klus.eindTijd}`,
      "yyyy-MM-dd HH:mm",
    );

    if (
      klusBegindatumtijd.toMillis() < validDienst.starttijd.toMillis() ||
      klusBegindatumtijd.toMillis() > validDienst.eindtijd.toMillis() ||
      klusEindDatumTijd.toMillis() < validDienst.starttijd.toMillis() ||
      klusEindDatumTijd.toMillis() > validDienst.eindtijd.toMillis()
    ) {
      return "Klus past niet binnen dienst";
    }
  }
  return "";
}
